var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddIcon, Button, CrossIcon, Dialog, EditIcon, Heading, IconButton, InfoSignIcon, Label, Pane, Paragraph, Table, TagInput, ThemeProvider, toaster, Tooltip, } from 'evergreen-ui';
import 'firebase/auth';
import 'firebase/firestore';
import moment from 'moment';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import ApoLocationInput from '../components/ApoLocationInput';
import ApoSegmentedControl from '../components/ApoSegmentedControl';
import ApoSelect from '../components/ApoSelect';
import ApoTextInput from '../components/ApoTextInput';
import BlueBar from '../components/BlueBar';
import DurationField from '../components/DurationField';
import { FavoritesGroupEditBar, FavoritesOriginResolver, } from '../components/Favorites';
import { FavoritesEditRow } from '../components/Favorites/FavoritesEditRow';
import FavoritesRow from '../components/Favorites/FavoritesRow';
import useFavoritesOriginResolver from '../components/Favorites/utils/use-favorites-origin-resolver';
import FeatureLabel from '../components/FeatureLabel';
import TableSortHeader from '../components/TableSortHeader';
import firebase from '../config';
import NavigatorBar from '../container/NavigatorBar';
import { LocationContext } from '../contexts/LocationContext';
import withPaywall from '../hocs/withPaywall';
import theme from '../theme';
import { usePlanInfo } from '../utility/use-plan-info';
import { createId } from '../utility/utility';
import PaywallInfo from './PaywallInfo';
var prios = [
    { label: 'Keine', value: 20 },
    { label: '!!!', value: 1 },
];
function Favorites() {
    var _this = this;
    var _a = useState([]), areFavs = _a[0], setFavs = _a[1];
    var _b = useState([]), areFavGroups = _b[0], setFavGroups = _b[1];
    var _c = useState({ visable: false, type: 'edit' }), isShown = _c[0], setShown = _c[1];
    var _d = useState(), selectedFav = _d[0], setSelectedFav = _d[1];
    var _e = useState(), dialogKey = _e[0], setDialogKey = _e[1];
    var _f = useState(), editMode = _f[0], setEditMode = _f[1];
    var _g = useState(), favName = _g[0], setFavName = _g[1];
    var _h = useState(), favPhone = _h[0], setFavPhone = _h[1];
    var _j = useState(), favMail = _j[0], setFavMail = _j[1];
    var _k = useState('delivery'), favType = _k[0], setFavType = _k[1];
    var _l = useState(null), focusedGroup = _l[0], setFocusedGroup = _l[1];
    var _m = useState(''), favNote = _m[0], setFavNote = _m[1];
    var _o = useState(), favLocation = _o[0], setFavLocation = _o[1];
    var _p = useState(''), earliest = _p[0], setEarliest = _p[1];
    var _q = useState(''), latest = _q[0], setLatest = _q[1];
    var _r = useState(null), processTime = _r[0], setProcessTime = _r[1];
    var _s = useState(), selectedBusinessId = _s[0], setSelectedBusinessId = _s[1];
    var _t = useState(''), search = _t[0], setSearch = _t[1];
    var _u = useState(null), selectedPrio = _u[0], setSelectedPrio = _u[1];
    var businessLocations = useContext(LocationContext).availableLocations;
    var itemsRef = useRef([]);
    var currentPlan = usePlanInfo().currentPlan;
    var businessLocationOptions = useMemo(function () {
        return (businessLocations || []).map(function (l) { return ({ label: l.name, value: l.id }); });
    }, [businessLocations]);
    useEffect(function () {
        if (!isShown.visable) {
            setSelectedFav(null);
            setDialogKey(moment.unix());
        }
    }, [isShown]);
    useEffect(function () {
        if (selectedFav) {
            setFavName(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.name);
            setFavPhone(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.phone);
            setFavMail(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.mail);
            setFavLocation(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.location);
            setFavType(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.type);
            setSelectedBusinessId(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.origin);
            setEarliest(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.earliest);
            setLatest(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.latest);
            setProcessTime(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.processTime);
            setFavNote(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.note);
            setSelectedPrio(selectedFav === null || selectedFav === void 0 ? void 0 : selectedFav.priority);
        }
        else {
            setFavName();
            setFavPhone();
            setFavMail();
            setFavLocation();
            setFavType();
            setSelectedBusinessId();
            setEarliest();
            setLatest();
            setProcessTime();
            setFavNote();
            setSelectedPrio(null);
        }
    }, [selectedFav, isShown]);
    function getFavorites() {
        firebase
            .firestore()
            .collection('favorites')
            .where('owner', '==', firebase.auth().currentUser.uid)
            .onSnapshot(function (snap) {
            var favs = [];
            snap.forEach(function (doc) {
                var data = doc.data();
                favs.push(data);
            });
            setFavs(favs);
        });
    }
    var getFavoritesGroup = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            firebase
                .firestore()
                .collection('favoritesGroup')
                .where('owner', '==', (_b = (_a = firebase === null || firebase === void 0 ? void 0 : firebase.auth()) === null || _a === void 0 ? void 0 : _a.currentUser) === null || _b === void 0 ? void 0 : _b.uid)
                .get()
                .then(function (snap) {
                var favs = [];
                snap.forEach(function (doc) {
                    var data = doc.data();
                    favs.push(data);
                });
                setFavGroups(favs);
            })
                .catch(function (err) { return console.log(err); });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        getFavorites();
        getFavoritesGroup();
    }, []);
    var _v = useFavoritesOriginResolver(), setIsShown = _v.setIsShown, addFavorites = _v.addFavorites;
    var runErrorCheck = function () {
        var favsWithError = areFavs.filter(function (fav) { return fav.origin === null; });
        if (favsWithError.length !== 0) {
            addFavorites(favsWithError);
            setIsShown(true);
        }
        else {
            toaster.success('Keine fehlerhaften Favoriten gefunden');
        }
    };
    var submit = function () {
        if (!favName || !favLocation) {
            toaster.notify('Sie müssen mindestens einen Namen und eine Adresse angeben!');
            return;
        }
        var uid = createId();
        firebase
            .firestore()
            .collection('favorites')
            .doc(uid)
            .set({
            name: favName,
            phone: favPhone !== null && favPhone !== void 0 ? favPhone : '',
            mail: favMail !== null && favMail !== void 0 ? favMail : '',
            type: favType !== null && favType !== void 0 ? favType : 'delivery',
            note: favNote !== null && favNote !== void 0 ? favNote : null,
            location: favLocation,
            earliest: earliest !== null && earliest !== void 0 ? earliest : '',
            latest: latest !== null && latest !== void 0 ? latest : '',
            processTime: processTime !== null && processTime !== void 0 ? processTime : null,
            origin: selectedBusinessId !== null && selectedBusinessId !== void 0 ? selectedBusinessId : businessLocations[businessLocations.length - 1].id,
            owner: firebase.auth().currentUser.uid,
            uid: uid !== null && uid !== void 0 ? uid : null,
            priority: selectedPrio ? parseInt(selectedPrio) : null,
        });
        setShown({ visable: false, type: 'edit' });
    };
    var update = function () {
        firebase
            .firestore()
            .collection('favorites')
            .doc(selectedFav.uid)
            .update({
            name: favName,
            phone: favPhone !== null && favPhone !== void 0 ? favPhone : '',
            mail: favMail !== null && favMail !== void 0 ? favMail : '',
            type: favType !== null && favType !== void 0 ? favType : 'delivery',
            note: favNote !== null && favNote !== void 0 ? favNote : null,
            location: favLocation,
            earliest: earliest !== null && earliest !== void 0 ? earliest : '',
            latest: latest !== null && latest !== void 0 ? latest : '',
            processTime: processTime !== null && processTime !== void 0 ? processTime : null,
            origin: selectedBusinessId !== null && selectedBusinessId !== void 0 ? selectedBusinessId : null,
            owner: firebase.auth().currentUser.uid,
            priority: selectedPrio ? parseInt(selectedPrio) : null,
        });
        setShown({ visable: false, type: 'edit' });
    };
    var remove = function (fav) {
        firebase
            .firestore()
            .collection('favorites')
            .doc(fav.uid)
            .delete()
            .then(function () { return toaster.success('Favorit erfolgreich gelöscht'); })
            .catch(function () { return toaster.warning('Favorit konnte nicht gelöscht werden'); });
    };
    // Filter and sort favorites
    var filteredFavs = useMemo(function () {
        var searchLower = search.toLowerCase();
        return areFavs
            .filter(function (fav) { return fav.name.toLowerCase().includes(searchLower); })
            .sort(function (a, b) { return a.name.localeCompare(b.name); });
    }, [areFavs, search]);
    var _w = useState(false), inCreation = _w[0], setInCreation = _w[1];
    var createGroup = function (name) {
        setInCreation(true);
        var selectedIds = itemsRef.current
            .filter(function (i) { return i.getSelected().state; })
            .map(function (i) { return i.getSelected().id; });
        var createFavoritesGroup = firebase
            .app()
            .functions('europe-west3')
            .httpsCallable('createFavoritesGroup');
        return createFavoritesGroup({ ids: selectedIds, name: name })
            .then(function (result) { return result; })
            .catch(function (err) { return err; })
            .finally(function () { return window.location.reload(); });
    };
    useEffect(function () {
        itemsRef.current = itemsRef.current.slice(0, filteredFavs.length);
    }, [filteredFavs]);
    var favGroupNames = useMemo(function () { return areFavGroups.map(function (g) { return g.name; }); }, [areFavGroups]);
    var updateFavoriteGroup = function (name) {
        var selectedIds = itemsRef.current
            .filter(function (i) { return i.getSelected().state; })
            .map(function (i) { return i.getSelected().id; });
        firebase
            .firestore()
            .collection('favoritesGroup')
            .doc(focusedGroup.uid)
            .update(__assign({ ids: selectedIds }, (focusedGroup.name !== name ? { name: name } : {})))
            .then(function () {
            toaster.success('Gruppe wurde erfolgreich geupdated');
            setFocusedGroup(null);
            window.location.reload();
        })
            .catch(function () { return toaster.danger(); });
    };
    var handleFilter = function (e) {
        var clickedGroup = e.target.innerText;
        var focusedGroup = areFavGroups.find(function (e) { return e.name === clickedGroup; });
        setFocusedGroup(focusedGroup);
    };
    var handleDeleteOfFavGroup = function (existingNames) { return __awaiter(_this, void 0, void 0, function () {
        var deletedFg;
        var _this = this;
        return __generator(this, function (_a) {
            deletedFg = areFavGroups
                .map(function (fg) { return (!existingNames.includes(fg.name) ? fg : []); })
                .flat();
            deletedFg.map(function (fg) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, firebase
                                .firestore()
                                .collection('favoritesGroup')
                                .doc(fg.uid)
                                .delete()
                                .then(function () { return toaster.success('Erfolgreich gelöscht'); })
                                .catch(function () { return toaster.warning('Fehler beim Löschen'); })
                                .finally(function () { return window.location.reload(); })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); };
    return (_jsxs(ThemeProvider, __assign({ value: theme }, { children: [_jsx(FavoritesOriginResolver, {}), _jsxs(Pane, __assign({ style: { display: 'flex', flexDirection: 'row' } }, { children: [_jsxs(Dialog, __assign({ isShown: isShown.visable, cancelLabel: "Abbrechen", confirmLabel: isShown.type === 'update' ? 'Speichern' : 'Hinzufügen', shouldCloseOnOverlayClick: false, shouldCloseOnEscapePress: false, onConfirm: isShown.type === 'update' ? update : submit, hasHeader: false, hasFooter: true, hasCancel: true, onCancel: function () { return setShown({ visable: false, type: '' }); }, contentContainerProps: {
                            className: 'dialog-content-container',
                            padding: 0,
                        }, containerProps: { className: 'square-corners' }, width: "80vw" }, { children: [_jsx(BlueBar, {}), _jsx(CrossIcon, { onClick: function () { return setShown({ visable: false, type: 'edit' }); }, style: {
                                    position: 'absolute',
                                    right: 20,
                                    top: 20,
                                    cursor: 'pointer',
                                } }), _jsxs(Pane, __assign({ display: 'flex', flex: 1 }, { children: [_jsxs(Pane, __assign({ style: {
                                            width: '50%',
                                            padding: 20,
                                            paddingBottom: 0,
                                        } }, { children: [_jsx(Heading, __assign({ size: 'large', marginBottom: 20 }, { children: "Favorit anlegen" })), _jsxs(Pane, __assign({ className: 'spaced-h-12-flx1', display: 'flex', flexDirection: 'row' }, { children: [_jsx(ApoTextInput, { label: "Name", required: true, placeholder: "Max Mustermann", value: favName, onChange: function (e) { return setFavName(e.target.value); } }), _jsx(ApoTextInput, { label: "Telefonnummer", 
                                                        // required
                                                        placeholder: "0800/666666", type: 'tel', value: favPhone, onChange: function (e) { return setFavPhone(e.target.value); } }), _jsx(ApoTextInput, { label: "E-Mail Adresse", value: favMail, type: 'email', placeholder: "mustermann@mail.de", onChange: function (e) { return setFavMail(e.target.value); } })] })), _jsx(Pane, __assign({ className: 'spaced-h-12-flx1', display: 'flex', flexDirection: 'row' }, { children: _jsx(ApoLocationInput, { label: favType === 'delivery' || favType === undefined
                                                        ? 'Lieferadresse'
                                                        : 'Abholadresse', required: true, defaultValue: favLocation, onChange: function (loc) { return setFavLocation(loc); } }) }))] })), _jsxs(Pane, __assign({ style: {
                                            width: '50%',
                                            padding: 20,
                                            backgroundColor: '#F9FAFC',
                                            paddingTop: 50,
                                        } }, { children: [_jsxs(Pane, __assign({ display: 'flex', flexDirection: 'row' }, { children: [_jsxs(Pane, __assign({ width: '50%', padding: 10, paddingBottom: 0, flexDirection: 'column' }, { children: [_jsx(ApoSegmentedControl, { required: true, label: 'Art', options: [
                                                                    { label: 'Lieferung', value: 'delivery' },
                                                                    { label: 'Abholung', value: 'pickup' },
                                                                ], onChange: function (type) { return setFavType(type); } }), _jsx(ApoSegmentedControl, { label: _jsx(Tooltip, __assign({ content: "Wenn die Lieferung als Eillieferung gilt, w\u00E4hle eine Priorit\u00E4t. Der Auftrag wird dann innerhalb der ersten 30 Minuten ausgefahren." }, { children: _jsxs(Pane, __assign({ style: { display: 'flex', flexDirection: 'row' } }, { children: [_jsx(Label, __assign({ fontSize: '15px', fontWeight: 400, display: 'block' }, { children: "Priorit\u00E4ten" })), _jsx(InfoSignIcon, { marginLeft: 5 })] })) })), options: prios, value: selectedPrio ? selectedPrio.toString() : '20', onChange: setSelectedPrio })] })), _jsxs(Pane, __assign({ width: '50%', padding: 10, paddingBottom: 0, display: 'flex', flexDirection: 'column' }, { children: [_jsx(ApoSelect, { required: true, label: 'Apotheke', options: businessLocationOptions, value: selectedBusinessId, onChange: function (e) { return setSelectedBusinessId(e.target.value); } }), _jsxs(Pane, __assign({ className: 'spaced-h-12-flx1', display: 'flex', flexDirection: 'row' }, { children: [_jsx(ApoTextInput, { label: "Ab", value: earliest, type: 'time', onChange: function (e) { return setEarliest(e.target.value); } }), _jsx(ApoTextInput, { label: "Bis", value: latest, type: 'time', onChange: function (e) { return setLatest(e.target.value); } })] })), _jsx(Pane, { children: _jsx(DurationField, { label: "Aufenthalt", value: processTime, onChange: function (e) { return setProcessTime(e); } }) })] }))] })), _jsx(Pane, __assign({ padding: 10, paddingTop: 0 }, { children: _jsx(ApoTextInput, { label: "Hinweis an den Fahrer", value: favNote, isTextarea: true, minHeight: 100, onChange: function (e) { return setFavNote(e.target.value); } }) }))] }))] }))] })), _jsx(NavigatorBar, {}), _jsxs(Pane, __assign({ elevation: 2, style: { padding: 25, margin: 25, width: '90vw', overflow: 'hidden' } }, { children: [_jsx(FeatureLabel, { type: "Plus-Feature", content: "Die Favoritenliste erm\u00F6glicht dir deine wiederkehrenden Rezeptabholstellen, \u00C4rzte, usw. zu speichern und mit einer Schnellauswahl in Auftr\u00E4gen zu verwenden." }), _jsx(Heading, __assign({ size: 900 }, { children: "Favoriten" })), _jsx(FavoritesGroupEditBar, { selectedFav: selectedFav, group: focusedGroup, update: updateFavoriteGroup, resetGroup: function () { return setFocusedGroup(null); } }), _jsx(FavoritesEditRow, { loading: inCreation, editMode: editMode, setEditMode: setEditMode, createGroup: createGroup }), _jsx(Paragraph, __assign({ size: 400 }, { children: "Hier k\u00F6nnen Sie eine Kundenkartei anlegen" })), currentPlan && currentPlan !== 'apomap-lite' && (_jsx(Button, __assign({ onClick: function () { return setShown({ visable: true, type: 'create' }); }, marginTop: 10, marginBottom: 10, iconBefore: AddIcon }, { children: "Hinzuf\u00FCgen" }))), _jsxs(Pane, __assign({ marginBottom: 4 }, { children: [_jsx(Paragraph, { children: "Favoritengruppen" }), _jsx(TagInput, { tagProps: function (value) {
                                            if (value === (focusedGroup === null || focusedGroup === void 0 ? void 0 : focusedGroup.name))
                                                return { color: '#49beef' };
                                            return {};
                                        }, disabled: favGroupNames.length === 0, onClick: handleFilter, onChange: function (v) { return handleDeleteOfFavGroup(v); }, values: favGroupNames }), _jsx(Button, __assign({ iconBefore: CrossIcon, marginLeft: 8, disabled: !focusedGroup, onClick: function () { return setFocusedGroup(null); } }, { children: "Filter l\u00F6schen" })), _jsx(Button, __assign({ iconBefore: AddIcon, marginLeft: 8, onClick: function () { return setEditMode(true); }, appearance: "primary" }, { children: "Neue Gruppe anlegen" }))] })), _jsxs(Table, { children: [_jsxs(Table.Head, __assign({ style: {} }, { children: [_jsxs("div", __assign({ style: {
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    maxWidth: '400px',
                                                    padding: 8,
                                                } }, { children: [_jsx(IconButton, { onClick: function () { return setEditMode(function (s) { return !s; }); }, icon: EditIcon, onp: true }), _jsx(Table.TextHeaderCell, { children: "Name" }), _jsx(TableSortHeader, { searchPlaceholder: 'Nach Namen filtern...', search: true, searchState: search, onSearchValueChange: setSearch })] })), _jsx(Table.TextHeaderCell, { children: "Adresse" }), _jsx(Table.TextHeaderCell, { children: "Aktion" })] })), _jsxs(Table.Body, __assign({ height: 400 }, { children: [filteredFavs.map(function (fav, i) {
                                                var _a;
                                                return (_jsx(FavoritesRow, { selected: focusedGroup ? (_a = focusedGroup === null || focusedGroup === void 0 ? void 0 : focusedGroup.ids) === null || _a === void 0 ? void 0 : _a.includes(fav.uid) : false, editMode: editMode || focusedGroup, ref: function (el) { return (itemsRef.current[i] = el); }, favorite: fav, setSelectedFav: setSelectedFav, setShown: setShown, remove: remove }, fav.uid));
                                            }), focusedGroup && _jsx(Pane, { height: 100 })] }))] })] }))] }), dialogKey)] })));
}
export default withPaywall(Favorites, 'apomap-plus', PaywallInfo('Favoriten', 'Hier können Sie eine Kundenkartei anlegen', 'apomap Plus', false, '', true));
